

import Developers from "@/models/general/settings/Developers";


export default {
    namespaced: true,
    state: () => ({
        events: [],
        webhooks: [],
        webhook: {},
       
    }),

    mutations: {
        setEvents(state, payload) {
            state.events = payload || [];
        },
        setWebhooks(state, payload) {
            state.webhooks = payload || [];
        },
        setWebhook(state, payload) {
            state.webhook = payload||{};
        },

    },

    actions: {
    
        async getAllEvents({ commit, state }) {
            try {
                commit("setLoading", true, { root: true });
                
                const { data } = await Developers.getAllEvents();

                commit("setEvents", data.data );

                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response?.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },
    
        async getAllWebhooks({ commit, state }, query = '') {
            try {
                commit("setLoading", true, { root: true });
                
                const { data } = await Developers.getAllWebhooks(query);

                commit("setWebhooks", data.data );

                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response?.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },
    
        async getWebhook({ commit, state }, id) {
            try {
                commit("setLoading", true, { root: true });
                
                const { data } = await Developers.getWebhook(id);

                commit("setWebhook", data.data );

                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response?.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },
    
        async createWebhook({ commit, state }, body) {
            try {
                commit("setLoading", true, { root: true });
                
                const { data } = await Developers.createWebhook(body);

                commit("setWebhooks", [{...data.data}, ...state.webhooks] );

                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response?.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },
    
        async updateWebhook({ commit, state, dispatch }, {id, body}) {
            try {
                commit("setLoading", true, { root: true });
                let webhooks = {...state.webhooks}
                const { data } = await Developers.updateWebhook(id, body);
                let stateWebhookIndex = webhooks.findIndex(x => x.store_event_id == id)
                if (stateWebhookIndex > -1) {
                    webhooks[stateWebhookIndex] = {...data.data}
                    commit("setWebhooks", webhooks );
                }else{
                   await dispatch("getAllWebhooks")
                }

                commit("setLoading", false, { root: true });
            } catch (ex) {
                await dispatch("getAllWebhooks")
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response?.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },
    
    }
};
